import React from 'react';
import {AccordionData} from "../../interfaces/AccordionData";
import {InputAccordion} from "./InputAccordion";
import {InfoAccordion} from "./InfoAccordion";


interface IProps {
    isInput: boolean,
    accordionTitle: string,
    data: AccordionData[],
    setData?: React.Dispatch<React.SetStateAction<AccordionData[]>>
}

export default function ABKAccordion({isInput, accordionTitle, data, setData}: IProps) {

    if (isInput && setData) return <InputAccordion title={accordionTitle} data={data} data1={setData}/>

    return <InfoAccordion title={accordionTitle} data={data}/>
}